export default {
    title: 'Ocorreu um erro',
    text: 'Usuário ou senha incorretos.',
    color: 'danger'
}